var _path, _line, _line2, _line3, _line4, _line5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationGameOver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 218,
    viewBox: "0 0 299 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.62 201.5H273.12H260.62C257.12 201.5 255.12 198.5 253.12 196C251.12 193.5 235.12 165.5 233.12 161.5C231.12 157.5 232.12 154.5 233.62 153.5C235.12 152.5 238.12 153 240.12 154.5C242.12 156 247.62 166 252.12 166C255.72 166 257.287 164 257.62 163C257.953 153.667 258.62 134.2 258.62 131C258.62 127 259.62 112.5 259.62 110.5C259.62 108.5 260.62 105.5 264.62 105.5C267.82 105.5 268.953 108.833 269.12 110.5L271.62 146C276.787 148.5 288.02 154.1 293.62 156.5C299.22 158.9 299.287 164.167 298.62 166.5C297.953 172.167 296.32 185.4 295.12 193C293.92 200.6 288.953 201.833 286.62 201.5Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 264.62,
    y1: 88,
    x2: 264.62,
    y2: 95,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 245.998,
    y1: 98.682,
    x2: 252.302,
    y2: 102.622,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 246.009,
    y1: 119.64,
    x2: 253.26,
    y2: 115.611,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 275.998,
    y1: 115.682,
    x2: 282.302,
    y2: 119.622,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 283.302,
    y1: 98.378,
    x2: 276.998,
    y2: 102.318,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 164.5L74.5 217.5V205.5L1 152.5V164.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 217.5L147.5 164.5V152.5L74.5 205.5V217.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 101L1 152.5L74.5 205.5L147.5 152.5L74.5 101Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 217.5L1 164.5V152.5M74.5 217.5L147.5 164.5V152.5M74.5 217.5V205.5M1 152.5L74.5 101L147.5 152.5M1 152.5L74.5 205.5M74.5 205.5L147.5 152.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 152.5L74.5 205.5V193.5L1 140.5V152.5Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 205.5L147.5 152.5V140.5L74.5 193.5V205.5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 89L1 140.5L74.5 193.5L147.5 140.5L74.5 89Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 205.5L1 152.5V140.5M74.5 205.5L147.5 152.5V140.5M74.5 205.5V193.5M1 140.5L74.5 89L147.5 140.5M1 140.5L74.5 193.5M74.5 193.5L147.5 140.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 140.5L74.5 193.5V181.5L1 128.5V140.5Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 193.5L147.5 140.5V128.5L74.5 181.5V193.5Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 77L1 128.5L74.5 181.5L147.5 128.5L74.5 77Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 193.5L1 140.5V128.5M74.5 193.5L147.5 140.5V128.5M74.5 193.5V181.5M1 128.5L74.5 77L147.5 128.5M1 128.5L74.5 181.5M74.5 181.5L147.5 128.5",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64.5L163.5 117.5V105.5L90 52.5V64.5Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 117.5L236.5 64.5V52.5L163.5 105.5V117.5Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 1L90 52.5L163.5 105.5L236.5 52.5L163.5 1Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 117.5L90 64.5V52.5M163.5 117.5L236.5 64.5V52.5M163.5 117.5V105.5M90 52.5L163.5 1L236.5 52.5M90 52.5L163.5 105.5M163.5 105.5L236.5 52.5",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationGameOver);
export default __webpack_public_path__ + "static/media/illustration_game-over.daebaf4dea6dfafda64e0ab146ec3f29.svg";
export { ForwardRef as ReactComponent };